import * as React from "react";

const Icon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="80" height="34" viewBox="0 0 80 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.21875" y="19.5156" width="3.42" height="3.42" rx="1.71" fill="#667080" />
    <rect x="7.78125" y="18.5156" width="72" height="6" rx="1" fill="#D9D9D9" />
    <rect x="0.21875" y="28.5156" width="3.42" height="3.42" rx="1.71" fill="#667080" />
    <rect x="7.78125" y="27.5156" width="72" height="6" rx="1" fill="#D9D9D9" />
    <rect x="7.78125" y="0.484375" width="72" height="6" rx="1" fill="#D9D9D9" />
    <rect x="0.21875" y="1.48438" width="3.42105" height="3.42105" rx="1.71053" fill="#667080" />
    <rect x="7.78125" y="9.51562" width="72" height="6" rx="1" fill="#D9D9D9" />
    <rect x="0.21875" y="10.5156" width="3.42105" height="3.42105" rx="1.71053" fill="#667080" />
  </svg>
);

export default Icon;
